import { queryOptions } from '@tanstack/react-query'
import { GroupSettingData } from '../../types/CompanyGroupSettings'
import { getCompanyGroupSettingsOptions } from './getCompanyGroupSettingsOptions'

type UseCompanyGroupSettingsOptionsProps<TData> = {
  companyId: string
  select?: (data: GroupSettingData) => TData
}

export const useCompanyGroupSettingsOptions = <TData = GroupSettingData>({
  companyId,
  select
}: UseCompanyGroupSettingsOptionsProps<TData>) => {
  return queryOptions(getCompanyGroupSettingsOptions(companyId, select))
}
